import { makeStyles } from '@material-ui/core'

export const useReportStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: 'white',
  },
  margin: {
    margin: theme.spacing(7),
  },
  avoidPageBreak: {
    pageBreakInside: 'avoid',
  },
  printContainer: {
    width: '1000px',
  },
}))
